<template>
	<div class="TeachClass_group_wrap" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
		<div class="top_title">
			<div class="goback" @click="goBack()"><img src="../../../../../static/images/course/icon-3.png"/><span>返回</span></div>
			<i></i>
			<b>小组管理</b>
		</div>
		<div class="title_btn">
			<h3>{{$route.query.className}}</h3>
			<div class="btnBox">
				<el-button type="primary" @click="queryProgress" v-if="isShowInitialize && professional!=8">查询进度</el-button>
				<el-button type="primary" @click="createGroup">创建小组</el-button>
				<el-button type="primary" @click="batchInitialization" v-if="isShowInitialize && professional!=8">数据初始化</el-button>
				<el-button type="primary" @click="autoGroup">自动分组</el-button>
				<!-- <el-button type="primary" @click="autoPost">自动换岗</el-button> -->
				<el-button type="primary" @click="delAllGroup">删除小组</el-button>
			</div>
		</div>
		<div class="table">
			<el-table
		    ref="multipleTable"
		    :data="tableData"
		    tooltip-effect="dark"
		    style="width: 100%"
		    :height="height"
		    :cell-style="cellStyle"
        :header-cell-style="headerCellStyle"
		    @selection-change="handleSelectionChange">
		    <el-table-column type="selection" width="50"></el-table-column>
		    <el-table-column label="序号" type="index" width="50">
		    	<template slot-scope="scope">{{(pageTotal.currentPage - 1) * pageTotal.pageSize + scope.$index + 1}}</template>
		    </el-table-column>
		    <el-table-column label="小组姓名" prop="name"></el-table-column>
		    <el-table-column label="小组标语" prop="title"></el-table-column>
		    <el-table-column label="小组成员" prop="studentNum"></el-table-column>
		    <el-table-column label="初始化" prop="initStatus" v-if="isShowInitialize && professional!=8">
		    	<template slot-scope="scope">
	          <span v-if="scope.row.initStatus==0" style="color: #F43D3D">账套待初始化</span>
	          <span v-if="scope.row.initStatus==1" style="color: #FFB23C">账套初始化中</span>
	          <span v-if="scope.row.initStatus==2" style="color: #03D57C">账套初始化成功</span>
	          <span v-if="scope.row.initStatus==3" style="color: #F43D3D">账套初始化失败</span>
	          <span v-if="scope.row.initStatus==4" style="color: #FFB23C">账套初始化中</span>
	        </template>
		    </el-table-column>
		    <el-table-column label="操作">
		    	<template slot-scope="scope">
		    		<span @click="initialization(scope.row)" style="margin-right: 10px;" v-if="isShowInitialize && professional!=8">初始化</span>
		    		<span @click="editGroup(scope.row)" style="margin-right: 10px;">编辑</span>
		    		<span @click="delGroup(scope.row)">删除</span>
		    	</template>
		    </el-table-column>
		    <template slot="empty">
        	<img src="../../../../../static/images/wujieguo.png"/>
        	<p>暂无小组</p>
        </template>
		  </el-table>
		  <pagination
        :currentpage="pageTotal.currentPage"
        :limit="pageTotal.pageSize"
        :total="pageTotal.total"
        layout="sizes, prev, pager, next, jumper"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :small="true"
        v-if="pageTotal.total>10"
      ></pagination>
		</div>
		<!--创建编辑小组-->
		<addteam-dialog ref="addteamDialog"
      :title="dialogTitle"
      :showModalconfirm="dialogFormVisible"
      :classId="Number($route.query.classId)"
      :courseId="Number($route.query.courseId)"
      :subjectId="Number(subjectId)"
      :groupId="Number(groupId)"
      :editGroupForm="editGroupForm"
      @cancelAddGroup="cancelAddGroup"
      @confirmAddGroup="confirmAddGroup"></addteam-dialog>
    <!--自动分组-->
    <auto-group
    	ref="autoGroup"
    	:showAutoGroup="showAutoGroup"
    	@cancelAutoGroup="cancelAutoGroup"
      @confirmAutoGroup="confirmAutoGroup"
    	>
    </auto-group>
		<el-dialog
			:modal="true"
			:modal-append-to-body="true"
			:visible.sync="InitializationPrompt"
			:close-on-click-modal="false"
			:show-close="true"
			:close-on-press-escape="true"
			:before-close="clickCancelTips"
			class="Initialization_prompt_wrap">
    <div class="progress_wrap" v-if="InitializationData.num>0">
			<div class="top">
				<div class="left">
					<img src="/static/images/progress.png" alt="">
				</div>
				<div class="right">
					<h3>数据初始化进行中........</h3>
					<p>当前排队小组数<span>{{InitializationData.num}}</span>个，预计仍需<span>{{InitializationData.time}}</span>分钟。</p>
				</div>
			</div>
			<div class="bot">
				<h3>友情提示</h3>
				<p>下次建议您在“备课”的同时，提前一天“初始化”所有的团队，感谢您的理解！</p>
			</div>
		</div>
		<div class="success_wrap" v-if="InitializationData.num==0">
			<img src="/static/images/success.png" alt="">
			<p>恭喜您，初始化已全部完成！</p>
		</div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="clickCancelTips">{{InitializationData.num>0 ? '知道了' : '好的'}}</el-button>
    </div>
  </el-dialog>
	</div>
</template>

<script>
	import Pagination from "../../../paginator/paginator.vue";
	import * as api from "../../../../api/individualApi";
	import addteamDialog from './addTeamDialog';
	import autoGroup from './autoGroup'
	import axios from "axios"
	export default {
		components:{
      Pagination,
      addteamDialog,
      autoGroup
    },
		data(){
			return {
				loading: true,
				tableData: [],
				userType: sessionStorage.getItem('userType'),
				multipleSelection: [],
				pageTotal: {
	        currentPage: 1,
	        pageSize: 10,
	        total: 0
	      },
	      height: null,
	      dialogTitle: '创建小组',
	      dialogFormVisible: false,
	      subjectId:'',
	      groupId:'',
	      editGroupForm:{
	        teamName:'',
	        teamSlogan:''
	      },
        showAutoGroup: false,
        professional: sessionStorage.getItem('professional'),
				InitializationPrompt: false,//初始化提示弹窗
				InitializationData:{
					num: 0,
					time: 0
				},
        isShowInitialize: false
			}
		},
		created(){
			this.getGroup();
			this.getList();
			this.getInitializationProgress()
		},
		methods: {
			goBack(){
				this.$router.go(-1);
				this.$store.state.activeName = this.$route.query.index;
			},
			// 获取小组列表
			getGroup(){
				let obj = {
					classId: this.$route.query.classId,
					courseId: this.$route.query.courseId,
					limit: this.pageTotal.pageSize,
					page: this.pageTotal.currentPage,
					type: 2,
					userType: "2"
				}
				api.getGroupList(obj).then(res=>{
					if(res.code == 0){
						this.loading = false;
						this.tableData = res.data.list;
						this.pageTotal.total = res.data.total;
						if(res.data.total > 10){
							this.height = window.innerHeight - 290+"px";
						}else{
							this.height = window.innerHeight - 220+"px";
						}
					}
				})
			},
			// 自动分组
			autoGroup(){
				this.showAutoGroup = true;
				this.$refs.autoGroup.getGroupPeopleNum();
				this.$refs.autoGroup.getMyStation();
			},
			cancelAutoGroup(){
				this.showAutoGroup = false;
			},
			confirmAutoGroup(peopleNum){
				let obj = {
					courseId: this.$route.query.courseId,
					classId: this.$route.query.classId,
					subjectId: this.$route.query.subjectId,
					peopleNum: peopleNum
				}
				api.saveAutoGroup(obj.courseId,obj.classId,obj.subjectId,obj.peopleNum).then(res=>{
					if(res.code == 0){
						this.$messageSuccess('自动分组成功')
						this.showAutoGroup = false;
						this.getGroup();
					}else{
						this.$messageError(res.msg);
					}
				})
	    },
	    // 自动换岗
	    autoPost(){
	    	this.$tipsDialog(
	        "提示",
	        "是否给所有小组学员进行换岗？",
	        "",
	        "el-icon-warning",
	        "rgb(255, 178, 60)"
	      ).then(() => {
	        let arr = [];
		    	this.tableData.forEach(val=>{
		    		let obj = {};
		    		obj.id = val.id;
		    		obj.courseId = val.courseId;
		    		obj.classId = val.classId;
		    		arr.push(obj);
		    	})
		    	api.automaticShift(arr).then(res=>{
		    		if(res.code == 0){
		    			this.$messageSuccess('自动换岗成功');
		    			this.getGroup();
		    		}else{
		    			this.$messageError(res.msg)
		    		}
		    	})
	      }).catch(() => {

	      });
	    },
			// 创建小组
			createGroup(){
	      this.dialogTitle = '创建小组'
	      this.dialogFormVisible = true
	    },
			// 编辑小组
			editGroup(row){
	      this.groupId = row.id
	      this.editGroupForm = {
	        teamName:row.name,
	        teamSlogan:row.title
	      }
	      this.dialogTitle = '编辑小组'
	      this.dialogFormVisible = true
	    },
			cancelAddGroup(){
	      this.editGroupForm = {
	        teamName: '',
	        teamSlogan: ''
	      }
	      this.dialogFormVisible = false
	    },
	    confirmAddGroup(form,data){
	      let userArr = []
	      data.forEach((val,i)=>{
	        let userObj = {
	          "stationIds": val.postId,
	          "userId": val.studentUserId,
	          "userName": val.studentName
	        }
	        userArr.push(userObj)
	      })
	      let obj = {};
	      let request
	      if(this.dialogTitle=='编辑小组'){
	        obj = {
	          "classId": this.$route.query.classId,
	          "courseId": this.$route.query.courseId,
	          "id": this.groupId,
	          "name": form.teamName,
	          "subjectId": this.subjectId,
	          "title": form.teamSlogan,
	          "users": userArr
	        }
	        request = api.editorGroup(obj);
	      }else{
	        obj = {
	          "classId": this.$route.query.classId,
	          "courseId": this.$route.query.courseId,
	          "id": '',
	          "name": form.teamName,
	          "subjectId": this.subjectId,
	          "title": form.teamSlogan,
	          "users": userArr
	        }
	        request = api.createGroup(obj);
	      }
	      if(userArr.length==0){
	        this.$messageWarning('请添加小组成员')
	        return
	      }
	      request.then(rs=>{
	        if(rs.code==0){
	          if(this.dialogTitle=='编辑小组'){
	            this.$messageSuccess('小组信息修改成功')
	          }else{
	            this.$messageSuccess('小组创建成功')
	          }
	          this.editGroupForm = {
	            teamName: '',
	            teamSlogan: ''
	          }
	          this.getGroup();
	        }else{
	          this.$messageError(rs.msg)
	        }
	      }).catch(err=>{
	        console.log(err)
	      })
	      this.$refs.addteamDialog.resetFormFn();
	      this.dialogFormVisible = false
	    },
	    // 获取科目id
	    getList(){
	      let id = this.$route.query.classId;
	      if(id){
	        api.getSubjectId(id).then((data)=>{
	          if(data.code==0){
	            let obj = data.data;
              this.isShowInitialize = obj.isInitialize == 0 ? false : true
	            this.subjectId = obj.subjectId;
	          }else{
	            this.$messageError(data.msg)
	          }
	        },(e)=>{
	          this.$messageError(e)
	        })
	      }
	    },
			// 单个初始化
			initialization(row){
				let arr = [];
				arr.push(row.id);
				if (row.initStatus==1||row.initStatus==2) {
          let str = ''
          if(row.initStatus==1){
            str = '小组“'+row.name+'”正在初始化'
          }else if(row.initStatus==2){
            str = '小组“'+row.name+'”已初始化'
          }
          this.$messageWarning(str);
          return
        }
				let obj = {
          "classId": this.$route.query.classId,
          "courseId": this.$route.query.courseId,
          "ids": arr,
          "status": 1,
          "type": 1
        }
				this.initializationFn(obj)
			},
			// 批量初始化账套
			batchInitialization(){
				let arr = []
	      let isEmpty = 0;
	      let groupName = '';
				if(this.multipleSelection.length){
					this.multipleSelection.forEach(val=>{
						arr.push(val.id)
	          isEmpty = val.initStatus;
	          groupName = val.name
					});
	        if (isEmpty==1||isEmpty==2) {
	          let str = ''
	          if(isEmpty==1){
	            str = '小组“'+groupName+'”正在初始化'
	          }else if(isEmpty==2){
	            str = '小组“'+groupName+'”已初始化'
	          }
	          this.$messageWarning(str);
	          return
	        }
	        let obj = {
	          "classId": this.$route.query.classId,
	          "courseId": this.$route.query.courseId,
	          "ids": arr,
	          "status": 1,
	          "type": 1
	        }
	        this.initializationFn(obj)
				}else{
	        this.$messageWarning("请选择需要初始化的小组");
				}
			},
			initializationFn(obj){
				// let that = this
				// if(this.professional==1){
				// 	let src = `${process.env.ZLJT_API}/api-audit/initData/initAuditData`;
				// 	let classId = this.$route.query.classId
				// 	let courseId = this.$route.query.courseId
				// 	let params = {
				// 		courseId: courseId,
				// 		classId: classId,
				// 		platForm: 3,//平台信息 1:考试 2:大赛 3:实训 4:单项 5:书证融通
				// 		// matchPlanId: matchPlanId,
				// 		// qstIds: qstIds,
				// 	};
				// 	axios.post(src, params).then(rs=>{
				// 		if(rs.data.code==0){
				// 			this.$messageSuccess('初始化成功')
				// 			this.getGroup();
				// 		}else{
				// 			this.$messageError(rs.data.mag)
				// 		}
				// 	})
				// }else{
					api.initialization(obj).then(rs=>{
						if(rs.code==0){
							this.getGroup();
						}else{
							this.$messageError(rs.mag)
						}
					}).catch(err=>{
						console.log(err)
					})
				// }
			},
			// 单个删除小组
			delGroup(row){
				this.$tipsDialog(
	        "提示",
	        "确定删除该小组吗？",
	        "",
	        "el-icon-warning",
	        "rgb(255, 178, 60)"
	      ).then(() => {
	        api.delGroup(row.id).then(rs=>{
	          if(rs.code==0){
	            this.$messageSuccess('小组删除成功')
	            this.getGroup();
	          }else{
	            this.$messageError(rs.msg)
	          }
	        }).catch(err=>{
	          console.log(err)
	        })
	      }).catch(() => {

	      });
			},
			// 批量删除小组
			delAllGroup(){
				if(this.multipleSelection.length){
					this.$tipsDialog(
	          "提示",
	          "确定删除选中的小组吗？",
	          "",
	          "el-icon-warning",
	          "rgb(255, 178, 60)"
	        ).then(() => {
	          let arr = []
	          this.multipleSelection.forEach(val=>{
	            arr.push(val.id)
	          });
	          let obj = {
	          	ids:arr
	          }
	          api.delAllGroup(obj).then(rs=>{
	            if(rs.code==0){
	              this.$messageSuccess('小组删除成功')
                this.pageTotal= {
                  currentPage: 1,
                    pageSize: 10,
                    total: 0
                };
	              this.getGroup();
	            }else{
	              this.$messageError(rs.msg)
	            }
	          }).catch(err=>{
	            console.log(err)
	          })
	        }).catch(() => {

	        });
				}else{
					this.$messageWarning('请选择要删除的小组')
				}
			},
			handleSelectionChange(val) {
        this.multipleSelection = val;
     	},
     	handleCurrentChange(val) {
	      this.pageTotal.currentPage = val;
	      this.getGroup();
	   	},
	   	handleSizeChange(val){
	   		this.pageTotal.pageSize = val;
	   		this.pageTotal.currentPage = 1;
	      this.getGroup();
	   	},
     	headerCellStyle({ row, column, rowIndex, columnIndex }){
	    	if (rowIndex === 0 && columnIndex === 0) {
	        return "text-algin:center !important;"
	      }else{
	      	return "text-algin:left !important"
	      }
	    },
	    cellStyle(data){
	    	if(data.columnIndex == 0){
	        return "text-algin:center !important"
	      }else{
	      	return "text-algin:left !important"
	      }
	    },
			getInitializationProgress(type){//初始化进度查询
				let classId = this.$route.query.classId
				let courseId = this.$route.query.courseId
				let platform = this.professional
				api.getInitializationProgress(courseId, classId, platform).then(rs=>{
					if(rs.code==0){
						if(rs.data==0){
							this.InitializationData.num = rs.data
							this.InitializationData.time = rs.data
						}else if(rs.data>0){
							this.InitializationData.num = rs.data
							let time = rs.data * 5
							if(time > 60){
								this.InitializationData.time = Math.ceil(time/60)
							}else{
								this.InitializationData.time = 1
							}
						}else{
							this.InitializationData.num = -1
						}
						if(type && type==1){
							if(this.InitializationData.num > 0){
								this.InitializationPrompt = true
                this.getGroup();
							}else{
								// this.$messageError('初始化进度异常')
								this.$messageError('正在初始化中')
							}
						}else{
							if(this.InitializationData.num > 0){
								this.InitializationPrompt = true
							}
						}
					}else{
						this.$messageError(rs.msg)
					}
				})
			},
			queryProgress(){//初始化进度查询
				this.getInitializationProgress(1)
			},
			clickCancelTips(){//关闭初始化提示
				this.InitializationPrompt = false
			}
		}
	}
</script>

<style lang="scss" scoped>
	.TeachClass_group_wrap {
		margin: 16px;
		margin-bottom: 0;
		background: #fff;
		.top_title {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			margin: 0 20px;
			padding: 20px 0;
			border-bottom: 1px solid #DDE0E2;
			.goback {
				display: flex;
				align-items: center;
				font-size: 12px;
				cursor: pointer;
				img {
					display: inline-block;
					width: 18px;
					height: 18px;
					margin-right: 8px;
				}
			}
			i {
				width:4px;
				height:12px;
				background:rgba(83,151,247,1);
				margin: 0 10px;
			}
			b {
				font-size: 16px;
				color: #0D141E;
				font-weight: bold;
			}
		}
		.title_btn {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 16px 20px;
			h3 {
				font-size: 16px;
				color: #0D141E;
				font-weight: bold;
			}
			.btnBox {
				.el-button {
					padding: 8px 11px;
				}
			}
		}
		.table {
			padding: 0 20px;
			/deep/ .el-table {
				td .cell {
					height: 40px;
					line-height: 40px;
					background: #F6F8FB;
					margin-bottom: 8px;
					span {
						cursor: pointer;
						color: #545A64;
						&:hover {
							color: #5397F7;
						}
					}
				}
				th {
					.cell {
						background: transparent;
					}
				}
				td,th {
					padding: 0;
					height: 40px;
				}
				tr {
					margin-bottom: 8px;
					&:hover {
						background: transparent;
					}
				}
				td {
					padding-bottom: 8px;
				}
				td,th.is-leaf {
					border: 0;
				}
				th.is-leaf {
					&:nth-child(1) {
						padding-left: 3px;
					}
				}
			}
		}
		.Initialization_prompt_wrap{
			/deep/ .el-dialog{
				width: 420px;
				height: 270px;
				background: #FFFFFF;
				border-radius: 4px;
				.el-dialog__header{
					display: none;
				}
				.el-dialog__body{
					padding: 37px 37px 23px 37px;
					.progress_wrap{
						.top{
							display: flex;
							margin-bottom: 36px;
							margin-top: 2px;
							.left{
								margin-left: 10px;
								margin-right: 18px;
								img{
									width: 40px;
									height: 40px;
								}
							}
							.right{
								flex: 1;
								h3{
									font-size: 14px;
									font-weight: 500;
									color: #595964;
									line-height: 20px;
								}
								p{
									font-size: 12px;
									font-weight: 400;
									color: #999999;
									line-height: 25px;
									span{
										&:first-child{
											color: #0F0D11;
										}
										&:last-child{
											color: #09C579;
										}
									}
								}
							}
						}
						.bot{
							width: 346px;
							height: 72px;
							background: rgba($color: #F5F5F7, $alpha: 0.75);
							border-radius: 4px;
							padding: 3px 10px;
							box-sizing: border-box;
							h3{
								font-size: 12px;
								font-weight: 600;
								color: #0F0D11;
								line-height: 23px;
							}
							p{
								font-size: 12px;
								color: #595964;
								line-height: 23px;
							}
						}
					}
					.success_wrap{
						text-align: center;
						img{
							width: 70px;
							height: 70px;
							margin-top: 13px;
						}
						p{
							font-size: 16px;
							font-weight: 500;
							color: #595964;
							line-height: 22px;
							margin-top: 20px;
							margin-bottom: 20px;
						}
					}
				}
				.el-dialog__footer{
					padding: 0;
					button{
						width: 108px;
						height: 35px;
						background: linear-gradient(135deg, #1890FF 0%, #00B3F7 100%, #00B3F7 100%);
						border-radius: 7px;
						padding: 0;
						color: #fff;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/TeachClass/components/groupAdmin.vue